/* eslint-disable react/no-is-mounted */
export default class BaseCommunicator {
  model: any = null;
  initialized = false;

  constructor(model: object) {
    this.model = model;
    this.emit('initialized', {});
  }

  getModel() {
    return this.model;
  }

  emit(type: string, data: object) {
    this.model
      .then((parent: any) => {
        parent.emit(type, data);
        if (type === 'initialized') this.initialized = true;
      })
      .catch((error: any) => {
        console.log('failed to handle csrbuddy event', error);
      });

    return;
  }
}
